export const DROPBOX_PATH = "dropbox-code";
export const TARGET = "DropboxAuthPopup";
export const TYPE = "DROPBOX_TOKEN";
export const HEIGHT = 600;
export const WIDTH = 600;
